// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PrizeTile-module-prizeTile-Wn8uz{border-radius:8px;border:1px solid rgba(0,0,0,.2);background:#fbfbfb}@media(max-width: 480px){.PrizeTile-module-prizeTile-Wn8uz{display:flex;justify-content:center}}.PrizeTile-module-prizeTileContent-33D_p{padding:25px;display:flex;flex-direction:column;gap:25px}.PrizeTile-module-imageWrapper-1qHyP{max-width:300px;position:relative;height:90px;border-radius:8px;overflow:hidden}.PrizeTile-module-imageWrapper-1qHyP img{width:100%;border-radius:8px}.PrizeTile-module-venue-2Es3P{cursor:pointer}.PrizeTile-module-title-P5Toe{font-size:18px;line-height:23px}.PrizeTile-module-infoWrapper-P-7Bc{display:flex;flex-direction:column;gap:10px}", ""]);
// Exports
exports.locals = {
	"prizeTile": "PrizeTile-module-prizeTile-Wn8uz",
	"prizeTileContent": "PrizeTile-module-prizeTileContent-33D_p",
	"imageWrapper": "PrizeTile-module-imageWrapper-1qHyP",
	"venue": "PrizeTile-module-venue-2Es3P",
	"title": "PrizeTile-module-title-P5Toe",
	"infoWrapper": "PrizeTile-module-infoWrapper-P-7Bc"
};
module.exports = exports;
